module.exports = __webpack_public_path__ + "static/media/acc.d7b64a48.webp";